import { useAppDispatch } from "../redux/hooks";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { clearAuthSlice } from "../redux/authSlice";
import { showToaster } from "../redux/toastSlice";
import { disconnectWebSocketConnection } from "../services/sharedService";

const axiosApiInstance = axios.create();

export const AuthInterceptor = () => {
    const dispatch = useAppDispatch();
    let navigate = useNavigate();

    // Request interceptor
    axios.interceptors.request.use(
        async function (config: any) {
            // Updating the request header.
            if (!config.headers["Content-Type"]) {
                config.headers["Content-Type"] = "application/json";
                config.headers.Accept = "application/json";
            }
            config.headers["Access-Control-Allow-Origin"] = "*";
            config.headers["Access-Control-Allow-Methods"] =
                "POST, GET, PUT, OPTIONS, DELETE";
            let token = localStorage.getItem("access_Token");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            const env = process.env.REACT_APP_ENV
                ? process.env.REACT_APP_ENV
                : "dev";
            let tenant_id = "";
            if (env === "local") {
                tenant_id = process.env.REACT_APP_tenant
                    ? process.env.REACT_APP_tenant
                    : "";
            } else {
                const domain_url = process.env.REACT_APP_DOMAIN_URL
                    ? process.env.REACT_APP_DOMAIN_URL
                    : ".dev.rcmanagers.com";
                const host = window.location.host;
                const domain_prefix = host.replace(domain_url, "");
                tenant_id = process.env[`REACT_APP_${domain_prefix}`] ?? "";
            }
            if (!config.headers["tenant"]) {
                config.headers["tenant"] = tenant_id;
            }
            return config;
        },
        function (error: any) {
            return Promise.reject(error);
        }
    );

    // Response interceptor
    axios.interceptors.response.use(
        function (response: any) {
            return response;
        },
        async function (error: any) {
            const originalRequest = error.config;
            const promise = new Promise((resolve, reject) => {
                if (
                    error.response &&
                    (error.response.status === 403 ||
                        error.response.status === 401 ||
                        (error.response.status === 0 &&
                            error.code === "ERR_NETWORK")) &&
                    !originalRequest._retry
                ) {
                    let canReloadPage: boolean = false;
                    if (
                        error.response.status === 0 &&
                        error.code === "ERR_NETWORK"
                    ) {
                        canReloadPage = false;
                        dispatch(
                            showToaster({
                                dialogBgColor: "bg-danger",
                                dialogMsg:
                                    "Unable to connect to the server. Kindly try again.",
                                showDialog: true,
                                timer: "5000",
                            })
                        );
                    } else {
                        // canReloadPage = true;
                        dispatch(
                            showToaster({
                                dialogBgColor: "bg-danger",
                                dialogMsg:
                                    (error.response.data &&
                                    error.response.data.message)
                                        ? error.response.data.message
                                        : "Something went wrong.",
                                showDialog: true,
                                timer: "5000",
                            })
                        );
                    }
                    originalRequest._retry = true;
                    localStorage.clear();
                    dispatch(clearAuthSlice());
                    navigate("/sign-in");
                    if (canReloadPage) {
                        disconnectWebSocketConnection();
                    }
                    resolve(axiosApiInstance(originalRequest));
                } else {
                    reject(error);
                }
            });
            return promise;
        }
    );
};
